import React from "react";

export default function Hero({
  title = [],
  description = [],
  titleLines = "",
  backgroundImage,
  gradientOverlay = "bg-gradient-to-r from-purple-900/90 via-purple-900/80 to-orange-500/70",
}) {
  return (
    <div className="relative min-h-[600px] sm:min-h-[700px] lg:min-h-screen overflow-hidden flex items-center">
      {/* Background Image */}
      <img
        src={backgroundImage}
        alt="Background visual"
        className="absolute inset-0 object-cover w-full h-full scale-x-[-1]"
      />

      {/* Gradient Overlay */}
      <div className={`absolute inset-0 ${gradientOverlay}`}></div>

      {/* Content */}
      <div className="relative z-10 w-full px-6 mx-auto max-w-7xl">
        <div className="max-w-3xl space-y-4 text-left">
          <h1 className="space-y-2">
            {titleLines.length > 0 ? (
              titleLines.map((line, idx) => (
                <span
                  key={idx}
                  className="block text-2xl font-normal text-white sm:text-3xl lg:text-4xl"
                  dangerouslySetInnerHTML={{ __html: line }}
                />
              ))
            ) : (
              <span
                className="block text-2xl font-normal text-white sm:text-3xl lg:text-4xl"
                // dangerouslySetInnerHTML={{ __html: title || defaultTitle }}
              >{title}</span>
            )}
          </h1>

          <div className="space-y-3">
            <p className="text-base leading-snug text-gray-200 sm:text-lg">
              {description}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
